import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appId", "oAuthorAccountId", "providerKey", "registry", "usePortal"];
import { useCallback, useState } from 'react';
import { useHeadlessOAuthLauncher, HeadlessOAuthWindowProvider } from 'unified-auth-core-lib';
import { defaultRegistry, useResolvedProvider } from './registry';
import { deleteAccount as deleteAccountAction } from './deleteAccount';
import { uninstallApp as uninstallAppAction } from './uninstallApp';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export function useUnifiedAccount(options, callbacks) {
  const {
      appId,
      oAuthorAccountId,
      providerKey,
      registry = defaultRegistry
    } = options,
    modalProps = _objectWithoutPropertiesLoose(options, _excluded);
  const oAuthorMigrationParams = 'oAuthorAccountId' in options ? {
    oAuthorAccountId
  } : undefined;
  const {
    onComplete,
    onCancel
  } = callbacks;
  const {
    components,
    isLoading
  } = useResolvedProvider(appId, providerKey, registry);
  const [isOpen, setIsOpen] = useState(false);
  const {
    openOAuthPopup,
    oAuthWindow,
    flowKey
  } = useHeadlessOAuthLauncher(options.mode, options.appName);
  const openModal = useCallback(() => {
    if (isLoading) {
      console.warn('[useUnifiedAccount] Cannot open modal while provider is loading');
      return;
    }
    if (!components) {
      throw new Error(`[useUnifiedAccount] No auth provider found for appId: ${appId}`);
    }
    openOAuthPopup();
    setIsOpen(true);
  }, [components, appId, isLoading, openOAuthPopup]);
  const closeModal = useCallback(() => setIsOpen(false), []);
  const handleComplete = useCallback(response => {
    setIsOpen(false);
    onComplete(response);
  }, [onComplete]);
  const handleCancel = useCallback(() => {
    setIsOpen(false);
    onCancel === null || onCancel === void 0 || onCancel();
  }, [onCancel]);
  const ProviderModal = components === null || components === void 0 ? void 0 : components.Modal;
  const Modal = isOpen && ProviderModal ? /*#__PURE__*/_jsx(HeadlessOAuthWindowProvider, {
    oAuthWindow: oAuthWindow,
    children: /*#__PURE__*/_createElement(ProviderModal, Object.assign({}, modalProps, {
      key: flowKey,
      appId: appId,
      oAuthorMigrationParams: oAuthorMigrationParams,
      onComplete: handleComplete,
      onCancel: handleCancel
    }))
  }) : null;
  const deleteAccount = useCallback(accountId => deleteAccountAction(accountId, {
    appId,
    providerKey,
    registry
  }), [appId, providerKey, registry]);
  const uninstallApp = useCallback(() => uninstallAppAction({
    appId,
    providerKey,
    registry
  }), [appId, providerKey, registry]);
  return {
    openModal,
    closeModal,
    isOpen,
    isLoading,
    Modal,
    deleteAccount,
    uninstallApp
  };
}